//router
import IndexRouters from "./router/index"

//orlando boton
//scss
import "./assets/scss/hope-ui.scss"
import "./assets/scss/dark.scss"
import "./assets/scss/rtl.scss"
import "./assets/scss/custom.scss"
import "./assets/scss/customizer.scss"
import Loader from "./layouts/Loader"
import RedirectUserScreen from "./components/cco/auth/RedirectUserScreen"
import { useAuth0 } from '@auth0/auth0-react';
import { registerTokenProvider } from "./helpers/authToken";


function App() {

  const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();

  // Registro durante el render, NO en un useEffect. Los `useEffect` de los hijos
  // (los thunks de costingRouter) corren antes que los del padre, asi que con un
  // `useEffect` el primer lote de requests sale sin token y la app queda en blanco.
  // Es idempotente, asi que no molesta que corra en cada render.
  registerTokenProvider(getAccessTokenSilently);

  if(isLoading){
    return <Loader/>
  }

  return (
   
      <div className="App">
        {
        isAuthenticated
        ?
        
        <IndexRouters />
        
        :<RedirectUserScreen />
        }
      </div>
  );
}

export default App;

